import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { EmergencyFooter } from './components/EmergencyFooter';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { TeamPage } from './pages/TeamPage';
import { BlogPage } from './pages/BlogPage';
import { CareersPage } from './pages/CareersPage';
import { DotPhysicalPage } from './pages/DotPhysicalPage';
import { SkipTheLinePage } from './pages/SkipTheLinePage';
import { PatientPortalPage } from './pages/PatientPortalPage';
import { BookAppointmentPage } from './pages/BookAppointmentPage';
import { FindUsPage } from './pages/FindUsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen flex flex-col w-full bg-white text-navy-500" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" role="main" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/team" element={<TeamPage data-id="element-8" />} data-id="element-7" />
            <Route path="/blog" element={<BlogPage data-id="element-10" />} data-id="element-9" />
            <Route path="/careers" element={<CareersPage data-id="element-12" />} data-id="element-11" />
            <Route path="/dot-physical" element={<DotPhysicalPage data-id="element-14" />} data-id="element-13" />
            <Route path="/skip-the-line" element={<SkipTheLinePage data-id="element-16" />} data-id="element-15" />
            <Route path="/portal" element={<PatientPortalPage data-id="element-18" />} data-id="element-17" />
            <Route path="/book" element={<BookAppointmentPage data-id="element-20" />} data-id="element-19" />
            <Route path="/locations" element={<FindUsPage data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
        <EmergencyFooter data-id="element-23" />
        <Footer data-id="element-24" />
      </div>
    </BrowserRouter>;
}